import { useEffect, useState } from "react";
import axios from "axios";
import { StatusMessage } from "../../StatusMessage";
import { sendMessage } from "../../../context/utils";
import Loader from "../../common/Loader";
import { useSearchParams } from "react-router-dom";
import { useRedirectParams } from "../../../hooks/useRedirectParams";

const RedirectComplete = () => {
    const [tabDisplayed, setTabDisplayed] = useState("");
    const [searchParams] = useSearchParams();
    const getParam = useRedirectParams(searchParams);
    const [isLoading, setIsLoading] = useState(false);
 
    const txRef = getParam("tx_ref", ["txRef", "reference"]);
    const merchantKey = sessionStorage.getItem("merchantKey");

    useEffect(() => {
        const completeRedirect = async () => {
            setIsLoading(true);

            try {
                axios
                    .get(
                        `${process.env.REACT_APP_API_URL}pay/3ds/auth?reference=${encodeURIComponent(
                            txRef as string
                        )}`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "x-auth-token": merchantKey as string,
                                ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                                    "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN,
                                }),
                            },
                        }
                    )
                    .catch((err) => {
                        console.warn("3DS auth failed:", err?.message || err);
                    });

                const statusResponse = await axios.post(
                    `${process.env.REACT_APP_API_URL}nucleus/tnx/merchant/status`,
                    { tnxRef: txRef },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                            "x-auth-token": merchantKey as string,
                        },
                    }
                );

                const statusData = statusResponse.data;

                if (statusData.merchantUrl) {
                    window.location.href = statusData.merchantUrl;
                    return;
                }

                if (statusData.status === "success" && statusData.data?.txRef) {
                    setTabDisplayed("success");
                    setTimeout(() => {
                        sendMessage({ status: "Success", tnxRef: statusData.data.txRef });
                    }, 1000);
                    return;
                }

                if (statusData.status === "successful") {
                    setTabDisplayed("success");
                    setTimeout(() => {
                        sendMessage({ status: "Success", tnxRef: txRef });
                    }, 1000);
                } else if (statusData.status === "failed") {
                    setTabDisplayed("error");
                    setTimeout(() => {
                        sendMessage({ status: "ERROR", tnxRef: txRef });
                    }, 1000);
                } else {
                    setTabDisplayed("");
                }
            } catch (error) {
                setTabDisplayed("error");
                setTimeout(() => {
                    sendMessage({ status: "ERROR", tnxRef: txRef });
                }, 1000);
            } finally {
                setIsLoading(false);
            }
        };

        completeRedirect();
    }, [txRef, merchantKey]);

    if (isLoading) {
        return <Loader isLoading={isLoading} />;
    }

    if (tabDisplayed === "success" || tabDisplayed === "error") {
        return <StatusMessage type={tabDisplayed} />;
    }

    return <div>Validating your payment, please wait...</div>;
};

export default RedirectComplete;
